export const endpoints = {
    test: `https://31wh2joxqi.execute-api.us-east-1.amazonaws.com/test`,
    acceptance: `https://lc9kbpm6rj.execute-api.us-east-1.amazonaws.com/acceptance`,
    prod: `https://3awi2s4cs3.execute-api.us-east-1.amazonaws.com/prod`,
};
